import { createSlice } from '@reduxjs/toolkit'

const messengerBindingSlice = createSlice({
  name: 'messengerBinding',
  initialState: {
    version: 0,
  },
  reducers: {
    refreshMessengerBindingStatus: (state) => {
      state.version += 1
    },
  },
})

export const { refreshMessengerBindingStatus } = messengerBindingSlice.actions

export const selectMessengerBindingVersion = (state: any) =>
  state.messengerBinding?.version ?? 0

export default messengerBindingSlice.reducer
